// Common imports
const configureCommonStore = require('client-v2/common/state/store')

function configureStore(options) {
  return configureCommonStore({
    ...options,
    reducer: require('./reducer'),
    reviver: require('./record').reviver
  })
}

module.exports = configureStore
